<div class="modal-header">
    <h4 class="modal-title pull-left">
        {{itemToSave?.id ? "Modification "+title : "Enregistrement "+title}}
    </h4>

    <button mat-icon-button class="pull-right" (click)="bsModalRef.hide()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="modal-body" [ngBusy]="{
      busy: busySave,
      message: 'Veuillez patienter ...',
      backdrop: false
    }">
    <ng-container>
        <div class="row">
            <form class="m-1">
                <div class="row">
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1 select-container">
                        <label>Filiale :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select [(ngModel)]="filiale_id" (change)="load_filiale_data()" [disabled]="true"
                            placeholder="Choisissez " name="filiale_id" id="filiale_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsFiliale" [value]="item.id">{{ item?.libelle }}
                            </ng-option>
                        </ng-select>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                      <label>Code:
                          <span class="required_champs">*</span>
                      </label>
                      <input class="form-control custom-input"  [disabled]="itemToSave.id" placeholder="Code" autocomplete="off"
                          [(ngModel)]="itemToSave.code" name="code" autocomplete="off" type="text" />
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                      <label>Codification:
                          <span class="required_champs">*</span>
                      </label>
                      <input class="form-control custom-input"  [disabled]="itemToSave.id" placeholder="Codification" autocomplete="off"
                          [(ngModel)]="itemToSave.codification" name="codification" autocomplete="off" type="text" />
                  </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Nom :
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" placeholder="Nom" autocomplete="off"
                            [(ngModel)]="itemToSave.nom" name="nom" autocomplete="off" type="text" />
                    </div>
  
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                        <label>Prenom :
                            <span class="required_champs">*</span>
                        </label>
                        <input class="form-control custom-input" placeholder="Prenom" autocomplete="off"
                            [(ngModel)]="itemToSave.prenom" name="prenom" autocomplete="off" type="text" />
                    </div>
    
                    
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1 select-container">
                        <label>Agence :
                            <span class="required_champs">*</span>
                        </label>
                        <ng-select [(ngModel)]="itemToSave.agence_id"
                            placeholder="Choisissez " name="agence_id" id="agence_id" [multiple]="false"
                            [closeOnSelect]="true">
                            <ng-option *ngFor="let item of itemsAgence" [value]="item.id">{{ item?.libelle }}
                            </ng-option>
                        </ng-select>
                    </div>
  
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                      <label>Numéro compte bancaire :
                          <span class="required_champs">*</span>
                      </label>
                      <input class="form-control custom-input" placeholder="Compte bancaire" autocomplete="off"
                          [(ngModel)]="itemToSave.numero_compte" name="numero_compte" autocomplete="off" type="text" />
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                      <label>Matricule :
                          <!-- <span class="required_champs">*</span> -->
                      </label>
                      <input class="form-control custom-input" placeholder="Matricule" autocomplete="off"
                          [(ngModel)]="itemToSave.matricule" name="matricule" autocomplete="off" type="text" />
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                      <label>Email :
                          <span class="required_champs">*</span>
                      </label>
                      <input class="form-control custom-input" placeholder="Email" autocomplete="off"
                          [(ngModel)]="itemToSave.email" name="email" autocomplete="off" type="text" />
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                      <label>Boite postale :
                          <span class="required_champs">*</span>
                      </label>
                      <input class="form-control custom-input" placeholder="Boite postale" autocomplete="off"
                          [(ngModel)]="itemToSave.boite_postale" name="boite_postale" autocomplete="off" type="text" />
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                      <label>Téléphone :
                          <span class="required_champs">*</span>
                      </label>
                      <input class="form-control custom-input" placeholder="Téléphone" autocomplete="off"
                          [(ngModel)]="itemToSave.telephone" name="telephone" autocomplete="off" type="text" />
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                      <label>Taux de commission :
                          <span class="required_champs">*</span>
                      </label>
                      <input class="form-control custom-input" placeholder="Taux de commission" autocomplete="off"
                          [(ngModel)]="itemToSave.taux_commission" name="taux_commission" autocomplete="off" type="text" mask="separator" />
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mb-1" style="padding-left: 5px; padding-right: 5px">
                      <label>Image :
                          <!-- <span class="required_champs">*</span> -->
                      </label>
                      <input (change)="uploadFile($event)" class="form-control custom-input" autocomplete="off"
                          name="image" autocomplete="off" type="file" />
                  </div>
                </div>
            </form>

        </div>
    </ng-container>
</div>

<div class="modal-footer modal-footer-custom">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <button type="button" (click)="confirmSaveItem(itemToSave)" class="btn btn-md custom_btn_primary pull-right"
            [class.auth-spinner]="loading" [disabled]="loading">
            Sauvegarder
        </button>

        <button type="button" class="btn btn-md btn-cancel pull-right" (click)="bsModalRef.hide()">
            Fermer
        </button>
    </div>
</div>